import { createContext, useContext, useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router';
import { isEoe, isPunchoutPath } from '../../common/constants/pathVariables.js';
import { useAuth } from './AuthProvider.js';
import {
  clearSessionData,
  getSessionData,
  refreshCompanyInfoSession,
  subscribeSessionData,
} from './sessionDataStore.js';
import type { SessionData } from './sessionDataStore.js';
import type { ReactNode } from 'react';

export const SessionDataContext = createContext<SessionData>({});

export const SessionDataProvider = ({ children }: { children?: ReactNode }) => {
  const { authenticatedUser } = useAuth();
  const mdmId = authenticatedUser?.activeAccountMasterId;
  const { pathname } = useLocation();

  useEffect(() => {
    if (!mdmId) {
      clearSessionData();
      return;
    }
    void refreshCompanyInfoSession(mdmId, isEoe(pathname), isPunchoutPath(pathname));
  }, [mdmId, pathname]);

  const data = useSyncExternalStore(subscribeSessionData, getSessionData, getSessionData);
  return <SessionDataContext.Provider value={data}>{children}</SessionDataContext.Provider>;
};

export const useSessionData = (): SessionData => useContext(SessionDataContext);
